import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const ClassesSection = ({ formats, onOpenFormat }) => {
  return (
    <section
      id="classes"
      data-testid="class-formats-section"
      className="section"
      style={{ backgroundColor: "var(--bg)" }}
    >
      <div className="container-fx">
        <Reveal>
          <div className="max-w-2xl">
            <p className="eyebrow">The Formats</p>
            <h2
              className="display mt-5"
              style={{ fontSize: "clamp(2.2rem, 5vw, 3.6rem)", fontWeight: 500 }}
            >
              Four ways to{" "}
              <span className="accent-italic">train.</span>
            </h2>
            <p
              className="mt-5"
              style={{ color: "var(--text-2)", fontSize: "1rem", lineHeight: 1.7 }}
            >
              Every live online class opens with a 10–15 minute mobility and
              activation sequence, then evolves with the day&apos;s format. Tap any
              format to see what to expect before you join the live schedule.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {(formats || []).map((f, i) => (
            <Reveal key={f.id} delay={i * 0.08} className="h-full">
              <button
                type="button"
                data-testid={`class-format-card-${f.id}`}
                onClick={(event) => onOpenFormat(f, event.currentTarget)}
                className="class-format-card group relative flex h-full w-full flex-col overflow-hidden text-left"
                style={{
                  backgroundColor: "var(--surface-2)",
                  border: "1px solid var(--border-c)",
                  borderRadius: "var(--radius-lg)",
                  transition: "border-color 0.3s ease, transform 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-strong)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-c)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={f.image}
                    alt={f.name}
                    className="h-full w-full object-cover"
                    loading="lazy"
                    style={{ transition: "transform 0.6s ease" }}
                  />
                  <div
                    className="absolute inset-0"
                    style={{
                      background:
                        "linear-gradient(to top, rgba(27,23,18,0.95), rgba(27,23,18,0.15))",
                    }}
                  />
                  <span
                    className="eyebrow absolute left-5 top-5"
                    style={{ color: "var(--text)" }}
                  >
                    {f.days}
                  </span>
                </div>
                <div className="class-format-card__content flex flex-1 flex-col p-6">
                  <div className="class-format-card__heading flex items-start justify-between gap-3">
                    <h3
                      className="class-format-card__title font-serif"
                      style={{ fontSize: "1.5rem", color: "var(--text)" }}
                    >
                      {f.name}
                    </h3>
                    <ArrowUpRight
                      size={20}
                      style={{ color: "var(--bronze)", flexShrink: 0 }}
                    />
                  </div>
                  <p
                    className="class-format-card__tagline font-serif mt-1"
                    style={{
                      fontStyle: "italic",
                      color: "var(--bronze)",
                      fontSize: "0.95rem",
                    }}
                  >
                    {f.tagline}
                  </p>
                  <p
                    className="class-format-card__description mt-4"
                    style={{
                      color: "var(--muted)",
                      fontSize: "0.86rem",
                      lineHeight: 1.6,
                    }}
                  >
                    {f.intro}
                  </p>
                  <span
                    className="class-format-card__action inline-flex items-center gap-2"
                    style={{
                      fontFamily: "var(--font-sans)",
                      textTransform: "uppercase",
                      letterSpacing: "0.16em",
                      fontSize: "0.68rem",
                      fontWeight: 600,
                      color: "var(--text-2)",
                    }}
                  >
                    View details
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
